import { defineMessages } from "locales/defineMessages";

export default defineMessages({
  vi: {
    "classDetail.noDate": "Chưa có ngày học",
    "classDetail.noDateShort": "Chưa có ngày",
    "classDetail.noTimeRange": "Chưa có khung giờ",
    "classDetail.noTimeShort": "Chưa có giờ",
    "classDetail.weekdayShort.0": "CN",
    "classDetail.weekdayShort.1": "T2",
    "classDetail.weekdayShort.2": "T3",
    "classDetail.weekdayShort.3": "T4",
    "classDetail.weekdayShort.4": "T5",
    "classDetail.weekdayShort.5": "T6",
    "classDetail.weekdayShort.6": "T7",
    "classDetail.dobNotUpdated": "Chưa cập nhật",
    "classDetail.dobLabel": "Ngày sinh: {dob}",
    "classDetail.sessionFallbackTitle": "Buổi học",
    "classDetail.unknownSessionName": "(Không rõ tên buổi)",

    "classDetail.auditAction.CLASS_CREATED": "Tạo lớp",
    "classDetail.auditAction.CLASS_UPDATED": "Cập nhật lớp",
    "classDetail.auditAction.CLASS_DELETED": "Xóa lớp",
    "classDetail.auditAction.CLASS_ENROLLMENT_ADDED": "Thêm học viên",
    "classDetail.auditAction.CLASS_ENROLLMENT_REMOVED": "Xóa học viên",
    "classDetail.auditAction.SESSION_CREATED": "Tạo buổi học",
    "classDetail.auditAction.SESSION_UPDATED": "Cập nhật buổi học",
    "classDetail.auditAction.SESSION_CANCELLED": "Hủy buổi học",
    "classDetail.auditAction.SESSION_COMPLETED": "Hoàn thành buổi học",
    "classDetail.auditAction.SESSION_ACTIVATED": "Bắt đầu buổi học",
    "classDetail.auditAction.SESSION_PARTICIPANTS_SYNCED":
      "Cập nhật thành phần buổi học",

    "classDetail.auditEntity.class": "Lớp học",
    "classDetail.auditEntity.session": "Buổi học",
    "classDetail.auditEntity.enrollment": "Đăng ký học",
    "classDetail.auditEntity.session_participant": "Thành phần buổi học",

    "classDetail.auditField.start_time": "giờ bắt đầu",
    "classDetail.auditField.end_time": "giờ kết thúc",
    "classDetail.auditField.duration_minutes": "thời lượng",
    "classDetail.auditField.status": "trạng thái",
    "classDetail.auditField.title": "tiêu đề",
    "classDetail.auditField.description": "mô tả",
    "classDetail.auditField.venue_id": "địa điểm",
    "classDetail.auditField.location": "vị trí",
    "classDetail.auditField.instructor_id": "người phụ trách",
    "classDetail.auditField.manager_ids": "quản lý lớp",
    "classDetail.auditField.trainer_ids": "huấn luyện viên",
    "classDetail.auditField.student_ids": "học viên",
    "classDetail.auditField.remaining_sessions": "số buổi còn lại",

    "classDetail.auditStatus.RESERVED": "Đặt chỗ",
    "classDetail.audit.emptyValue": "Không có",

    "classDetail.error.loadClass": "Không tải được thông tin lớp học",
    "classDetail.error.loadAudit": "Không tải được lịch sử thay đổi",
    "classDetail.error.classNotFound": "Không tìm thấy lớp học",
    "classDetail.error.venueRequired": "Vui lòng nhập tên và địa chỉ địa điểm",
    "classDetail.error.createVenue": "Không thể tạo địa điểm mới",
    "classDetail.error.pastStart":
      "Không thể tạo buổi học với giờ bắt đầu trong quá khứ.",
    "classDetail.error.sessionLocked":
      "Buổi học đang diễn ra hoặc đã xong không thể thay đổi lịch.",
    "classDetail.error.checkOverlap":
      "Không thể kiểm tra trùng lịch người tham gia",
    "classDetail.error.blockingOverlap":
      "Không thể thay đổi lịch vì trùng lịch huấn luyện viên/học viên:\n{detail}",
    "classDetail.error.updateSchedule": "Không thể cập nhật lịch buổi học",
    "classDetail.error.selectVenue":
      "Chọn địa điểm đã có sẵn hoặc tạo địa điểm mới kèm địa chỉ và tọa độ.",
    "classDetail.error.endBeforeStart":
      "Thời gian kết thúc phải sau thời gian bắt đầu",
    "classDetail.error.saveSession": "Lưu buổi học thất bại",
    "classDetail.error.deleteSession": "Không thể xóa buổi học",
    "classDetail.error.invalidRemaining": "Số buổi còn lại không hợp lệ",
    "classDetail.error.enrollStudent": "Thêm học viên thất bại",
    "classDetail.error.export": "Xuất file thất bại",

    "classDetail.confirm.deleteSession": "Xóa buổi học này?",
    "classDetail.confirm.rescheduleTitle": "Xác nhận đổi lịch buổi học",
    "classDetail.confirm.rescheduleMessage":
      'Bạn có chắc chắn muốn cập nhật lịch cho buổi "{title}"?',
    "classDetail.confirm.resizeTitle": "Xác nhận đổi thời lượng buổi học",
    "classDetail.confirm.resizeMessage":
      'Bạn có chắc chắn muốn thay đổi thời lượng cho buổi "{title}"?',
    "classDetail.confirm.createTitle": "Xác nhận tạo buổi học",
    "classDetail.confirm.createMessage":
      "Bạn có chắc chắn muốn tạo buổi học mới theo khung giờ đã chọn trên calendar không?",
    "classDetail.confirm.managerOverlapTitle":
      "Cảnh báo trùng lịch quản lý lớp",
    "classDetail.confirm.managerOverlapHint":
      "Quản lý lớp có thể phụ trách nhiều lớp cùng lúc. Bạn vẫn có thể xác nhận để lưu thay đổi.",

    "classDetail.export.button": "Xuất điểm danh",
    "classDetail.export.download": "Tải",
    "classDetail.noDescription": "Chưa cập nhật mô tả lớp học.",
    "classDetail.autoCreateSessions": "Tự động tạo buổi học hàng tuần",

    "classDetail.managers.loading": "Đang tải danh sách quản lý...",
    "classDetail.managers.empty": "Chưa có quản lý nào",
    "classDetail.managers.inCharge": "Phụ trách lớp",

    "classDetail.students.show": "Hiện học viên",
    "classDetail.students.hide": "Ẩn học viên",
    "classDetail.students.searchPlaceholder": "Tìm theo tên học viên...",
    "classDetail.students.add": "Thêm học viên",
    "classDetail.students.empty": "Chưa có học viên nào",
    "classDetail.students.noEmail": "Chưa có email",
    "classDetail.students.remaining": "Còn {count} buổi",

    "classDetail.sessions.title": "Lịch buổi học",
    "classDetail.sessions.count": "{count} buổi",
    "classDetail.sessions.add": "+ Thêm buổi",
    "classDetail.sessions.scheduledList": "Danh sách buổi đã lên lịch",
    "classDetail.sessions.emptyScheduled":
      "Chưa có buổi nào được gắn vào calendar.",
    "classDetail.sessions.warnNoStudentsNoManagers":
      "Buổi học chưa có học viên và chưa có quản lý lớp",
    "classDetail.sessions.warnNoStudents": "Buổi học chưa có học viên tham gia",
    "classDetail.sessions.warnNoManagers": "Buổi học chưa có quản lý lớp",
    "classDetail.sessions.outsideCheckinTitle":
      "Cho phép điểm danh ngoài phạm vi",
    "classDetail.sessions.outsideCheckin": "Ngoài phạm vi",

    "classDetail.preview.date": "Ngày học",
    "classDetail.preview.timeRange": "Khung giờ",
    "classDetail.preview.venue": "Địa điểm",
    "classDetail.preview.noAddress": "Chưa có địa chỉ",
    "classDetail.preview.hint":
      "Nhấn vào thẻ buổi học để mở chi tiết và chỉnh sửa nhanh.",

    "classDetail.calendar.title": "Calendar buổi học",
    "classDetail.calendar.hint":
      "Kéo-thả để đổi lịch, kéo cạnh event để đổi thời lượng, hoặc click event để sửa.",
    "classDetail.calendar.today": "Hôm nay",
    "classDetail.calendar.month": "Tháng",
    "classDetail.calendar.week": "Tuần",
    "classDetail.calendar.day": "Ngày",

    "classDetail.attendance.title": "Bảng điểm danh tháng",
    "classDetail.attendance.show": "Hiện bảng điểm danh",
    "classDetail.attendance.hide": "Ẩn bảng điểm danh",
    "classDetail.attendance.searchPlaceholder":
      "Tìm theo tên học viên hoặc nhân viên...",
    "classDetail.attendance.studentsTab": "Học viên ({count})",
    "classDetail.attendance.staffTab": "Nhân viên ({count})",
    "classDetail.attendance.colName": "Họ tên",
    "classDetail.attendance.colDob": "Ngày sinh",
    "classDetail.attendance.colRole": "Vai trò",
    "classDetail.attendance.colTotal": "Tổng",

    "classDetail.audit.title": "Lịch sử thay đổi",
    "classDetail.audit.show": "Hiện lịch sử thay đổi",
    "classDetail.audit.hide": "Ẩn lịch sử thay đổi",
    "classDetail.audit.loading": "Đang tải lịch sử thay đổi...",
    "classDetail.audit.emailFilter": "Lọc theo email...",
    "classDetail.audit.allActions": "Tất cả loại thao tác",
    "classDetail.audit.allSessions": "Tất cả buổi học",
    "classDetail.audit.classOnly": "Chỉ thay đổi lớp học",
    "classDetail.audit.empty": "Chưa có bản ghi thay đổi.",
    "classDetail.audit.noMatch": "Không có bản ghi phù hợp bộ lọc.",
    "classDetail.audit.systemActor": "Hệ thống",
    "classDetail.audit.collapse": "Thu gọn",
    "classDetail.audit.expand": "Mở rộng",
    "classDetail.audit.noDetail": "Không có thay đổi chi tiết.",

    "classDetail.sessionForm.editTitle": "Chỉnh sửa buổi học",
    "classDetail.sessionForm.createTitle": "Tạo buổi học mới",
    "classDetail.sessionForm.duration": "Thời lượng (phút)",
    "classDetail.sessionForm.hasSchedule": "Buổi này đã có lịch cụ thể",
    "classDetail.sessionForm.start": "Bắt đầu",
    "classDetail.sessionForm.end": "Kết thúc",
    "classDetail.sessionForm.unscheduledHint":
      "Buổi học này đang ở trạng thái chưa xếp lịch. Bạn có thể kéo từ danh sách bên trái sang calendar bất cứ lúc nào.",
    "classDetail.sessionForm.venue": "Địa điểm học",
    "classDetail.sessionForm.hideVenueForm": "Ẩn form tạo địa điểm",
    "classDetail.sessionForm.showVenueForm": "+ Tạo địa điểm mới",
    "classDetail.sessionForm.selectVenue": "Chọn địa điểm có sẵn",
    "classDetail.sessionForm.loadingVenues": "Đang tải danh sách địa điểm...",
    "classDetail.sessionForm.venueAddress": "Địa chỉ: {address}",
    "classDetail.sessionForm.venueAddressWithCoords":
      "Địa chỉ: {address} • Tọa độ: {coords}",
    "classDetail.sessionForm.noAddress": "Chưa có",
    "classDetail.sessionForm.venueName": "Tên địa điểm",
    "classDetail.sessionForm.venueNamePlaceholder":
      "Ví dụ: Cơ sở A - Sân chính",
    "classDetail.sessionForm.address": "Địa chỉ",
    "classDetail.sessionForm.addressPlaceholder":
      "Ví dụ: 12 Nguyễn Huệ, Q1, TP.HCM",
    "classDetail.sessionForm.searchingAddress": "Đang tìm địa chỉ...",
    "classDetail.sessionForm.noAddressSuggestion":
      "Không tìm thấy gợi ý phù hợp",
    "classDetail.sessionForm.missingVietmapKey":
      "Chưa cấu hình REACT_APP_VIETMAP_SERVICE_KEY để gợi ý địa chỉ.",
    "classDetail.sessionForm.venueDescription": "Mô tả (tùy chọn)",
    "classDetail.sessionForm.venueDescriptionPlaceholder":
      "Ví dụ: Khu tập trong nhà",
    "classDetail.sessionForm.latitude": "Vĩ độ (latitude)",
    "classDetail.sessionForm.longitude": "Kinh độ (longitude)",
    "classDetail.sessionForm.creatingVenue": "Đang tạo...",
    "classDetail.sessionForm.createVenue": "Tạo địa điểm và chọn",
    "classDetail.sessionForm.participants":
      "Người tham gia thực tế của buổi học",
    "classDetail.sessionForm.studentCount": "{count} học viên",
    "classDetail.sessionForm.loadingParticipants":
      "Đang tải danh sách tham gia...",
    "classDetail.sessionForm.multiSelectHint":
      "Giữ Ctrl/Cmd để chọn nhiều quản lý.",
    "classDetail.sessionForm.selectTrainer": "Chọn huấn luyện viên",
    "classDetail.sessionForm.searchStudents": "Tìm học viên tham gia",
    "classDetail.sessionForm.studentNamePlaceholder": "Nhập tên học viên...",
    "classDetail.sessionForm.noClassStudents":
      "Chưa có học viên trong lớp để chọn tham gia buổi này.",
    "classDetail.sessionForm.delete": "Xóa buổi",
    "classDetail.sessionForm.saveChanges": "Lưu thay đổi",
    "classDetail.sessionForm.create": "Tạo buổi",

    "classDetail.enroll.title": "Thêm học viên vào lớp",
    "classDetail.enroll.subtitle":
      "Tìm kiếm và thêm nhanh học viên từ danh sách hiện có.",
    "classDetail.enroll.searchLabel": "Tìm học viên theo tên",
    "classDetail.enroll.loading": "Đang tải danh sách học viên...",
    "classDetail.enroll.noMatch": "Không tìm thấy học viên phù hợp",
    "classDetail.enroll.alreadyEnrolled": "Đã trong lớp",
    "classDetail.enroll.remainingSessions": "Số buổi còn lại",
    "classDetail.enroll.remainingPlaceholder": "Nhập số buổi...",
    "classDetail.enroll.adding": "Đang thêm...",
  },
  en: {
    "classDetail.noDate": "No date yet",
    "classDetail.noDateShort": "No date",
    "classDetail.noTimeRange": "No time slot yet",
    "classDetail.noTimeShort": "No time",
    "classDetail.weekdayShort.0": "Sun",
    "classDetail.weekdayShort.1": "Mon",
    "classDetail.weekdayShort.2": "Tue",
    "classDetail.weekdayShort.3": "Wed",
    "classDetail.weekdayShort.4": "Thu",
    "classDetail.weekdayShort.5": "Fri",
    "classDetail.weekdayShort.6": "Sat",
    "classDetail.dobNotUpdated": "Not set",
    "classDetail.dobLabel": "Date of birth: {dob}",
    "classDetail.sessionFallbackTitle": "Session",
    "classDetail.unknownSessionName": "(Unnamed session)",

    "classDetail.auditAction.CLASS_CREATED": "Create class",
    "classDetail.auditAction.CLASS_UPDATED": "Update class",
    "classDetail.auditAction.CLASS_DELETED": "Delete class",
    "classDetail.auditAction.CLASS_ENROLLMENT_ADDED": "Add student",
    "classDetail.auditAction.CLASS_ENROLLMENT_REMOVED": "Remove student",
    "classDetail.auditAction.SESSION_CREATED": "Create session",
    "classDetail.auditAction.SESSION_UPDATED": "Update session",
    "classDetail.auditAction.SESSION_CANCELLED": "Cancel session",
    "classDetail.auditAction.SESSION_COMPLETED": "Complete session",
    "classDetail.auditAction.SESSION_ACTIVATED": "Start session",
    "classDetail.auditAction.SESSION_PARTICIPANTS_SYNCED":
      "Update session participants",

    "classDetail.auditEntity.class": "Class",
    "classDetail.auditEntity.session": "Session",
    "classDetail.auditEntity.enrollment": "Enrollment",
    "classDetail.auditEntity.session_participant": "Session participants",

    "classDetail.auditField.start_time": "start time",
    "classDetail.auditField.end_time": "end time",
    "classDetail.auditField.duration_minutes": "duration",
    "classDetail.auditField.status": "status",
    "classDetail.auditField.title": "title",
    "classDetail.auditField.description": "description",
    "classDetail.auditField.venue_id": "venue",
    "classDetail.auditField.location": "location",
    "classDetail.auditField.instructor_id": "person in charge",
    "classDetail.auditField.manager_ids": "class managers",
    "classDetail.auditField.trainer_ids": "trainers",
    "classDetail.auditField.student_ids": "students",
    "classDetail.auditField.remaining_sessions": "remaining sessions",

    "classDetail.auditStatus.RESERVED": "Reserved",
    "classDetail.audit.emptyValue": "None",

    "classDetail.error.loadClass": "Couldn't load class details",
    "classDetail.error.loadAudit": "Couldn't load change history",
    "classDetail.error.classNotFound": "Class not found",
    "classDetail.error.venueRequired":
      "Please enter the venue name and address",
    "classDetail.error.createVenue": "Couldn't create the venue",
    "classDetail.error.pastStart":
      "Can't create a session that starts in the past.",
    "classDetail.error.sessionLocked":
      "Sessions that are in progress or completed can't be rescheduled.",
    "classDetail.error.checkOverlap":
      "Couldn't check participants for schedule conflicts",
    "classDetail.error.blockingOverlap":
      "Can't reschedule because of conflicts with trainers/students:\n{detail}",
    "classDetail.error.updateSchedule": "Couldn't update the session schedule",
    "classDetail.error.selectVenue":
      "Select an existing venue or create a new one with an address and coordinates.",
    "classDetail.error.endBeforeStart": "End time must be after start time",
    "classDetail.error.saveSession": "Failed to save session",
    "classDetail.error.deleteSession": "Couldn't delete the session",
    "classDetail.error.invalidRemaining":
      "Invalid number of remaining sessions",
    "classDetail.error.enrollStudent": "Failed to add student",
    "classDetail.error.export": "Export failed",

    "classDetail.confirm.deleteSession": "Delete this session?",
    "classDetail.confirm.rescheduleTitle": "Confirm reschedule",
    "classDetail.confirm.rescheduleMessage":
      'Are you sure you want to update the schedule for "{title}"?',
    "classDetail.confirm.resizeTitle": "Confirm duration change",
    "classDetail.confirm.resizeMessage":
      'Are you sure you want to change the duration of "{title}"?',
    "classDetail.confirm.createTitle": "Confirm new session",
    "classDetail.confirm.createMessage":
      "Are you sure you want to create a new session in the time slot selected on the calendar?",
    "classDetail.confirm.managerOverlapTitle":
      "Class manager schedule conflict",
    "classDetail.confirm.managerOverlapHint":
      "Class managers can be in charge of several classes at once. You can still confirm to save the change.",

    "classDetail.export.button": "Export attendance",
    "classDetail.export.download": "Download",
    "classDetail.noDescription": "No class description yet.",
    "classDetail.autoCreateSessions": "Automatically create weekly sessions",

    "classDetail.managers.loading": "Loading managers...",
    "classDetail.managers.empty": "No managers yet",
    "classDetail.managers.inCharge": "In charge",

    "classDetail.students.show": "Show students",
    "classDetail.students.hide": "Hide students",
    "classDetail.students.searchPlaceholder": "Search by student name...",
    "classDetail.students.add": "Add student",
    "classDetail.students.empty": "No students yet",
    "classDetail.students.noEmail": "No email",
    "classDetail.students.remaining": "{count} sessions left",

    "classDetail.sessions.title": "Session schedule",
    "classDetail.sessions.count": "{count} sessions",
    "classDetail.sessions.add": "+ Add session",
    "classDetail.sessions.scheduledList": "Scheduled sessions",
    "classDetail.sessions.emptyScheduled": "No sessions on the calendar yet.",
    "classDetail.sessions.warnNoStudentsNoManagers":
      "This session has no students and no class manager",
    "classDetail.sessions.warnNoStudents": "This session has no students",
    "classDetail.sessions.warnNoManagers": "This session has no class manager",
    "classDetail.sessions.outsideCheckinTitle":
      "Check-in allowed outside the venue area",
    "classDetail.sessions.outsideCheckin": "Outside area",

    "classDetail.preview.date": "Date",
    "classDetail.preview.timeRange": "Time",
    "classDetail.preview.venue": "Venue",
    "classDetail.preview.noAddress": "No address yet",
    "classDetail.preview.hint":
      "Click the session card to open details and edit quickly.",

    "classDetail.calendar.title": "Session calendar",
    "classDetail.calendar.hint":
      "Drag and drop to reschedule, drag an event's edge to change its duration, or click an event to edit it.",
    "classDetail.calendar.today": "Today",
    "classDetail.calendar.month": "Month",
    "classDetail.calendar.week": "Week",
    "classDetail.calendar.day": "Day",

    "classDetail.attendance.title": "Monthly attendance",
    "classDetail.attendance.show": "Show attendance table",
    "classDetail.attendance.hide": "Hide attendance table",
    "classDetail.attendance.searchPlaceholder":
      "Search by student or staff name...",
    "classDetail.attendance.studentsTab": "Students ({count})",
    "classDetail.attendance.staffTab": "Staff ({count})",
    "classDetail.attendance.colName": "Full name",
    "classDetail.attendance.colDob": "Date of birth",
    "classDetail.attendance.colRole": "Role",
    "classDetail.attendance.colTotal": "Total",

    "classDetail.audit.title": "Change history",
    "classDetail.audit.show": "Show change history",
    "classDetail.audit.hide": "Hide change history",
    "classDetail.audit.loading": "Loading change history...",
    "classDetail.audit.emailFilter": "Filter by email...",
    "classDetail.audit.allActions": "All action types",
    "classDetail.audit.allSessions": "All sessions",
    "classDetail.audit.classOnly": "Class changes only",
    "classDetail.audit.empty": "No changes recorded yet.",
    "classDetail.audit.noMatch": "No records match the filters.",
    "classDetail.audit.systemActor": "System",
    "classDetail.audit.collapse": "Collapse",
    "classDetail.audit.expand": "Expand",
    "classDetail.audit.noDetail": "No detailed changes.",

    "classDetail.sessionForm.editTitle": "Edit session",
    "classDetail.sessionForm.createTitle": "Create new session",
    "classDetail.sessionForm.duration": "Duration (minutes)",
    "classDetail.sessionForm.hasSchedule": "This session has a fixed schedule",
    "classDetail.sessionForm.start": "Start",
    "classDetail.sessionForm.end": "End",
    "classDetail.sessionForm.unscheduledHint":
      "This session isn't scheduled yet. You can drag it from the list on the left onto the calendar at any time.",
    "classDetail.sessionForm.venue": "Venue",
    "classDetail.sessionForm.hideVenueForm": "Hide new venue form",
    "classDetail.sessionForm.showVenueForm": "+ Create new venue",
    "classDetail.sessionForm.selectVenue": "Select an existing venue",
    "classDetail.sessionForm.loadingVenues": "Loading venues...",
    "classDetail.sessionForm.venueAddress": "Address: {address}",
    "classDetail.sessionForm.venueAddressWithCoords":
      "Address: {address} • Coordinates: {coords}",
    "classDetail.sessionForm.noAddress": "None",
    "classDetail.sessionForm.venueName": "Venue name",
    "classDetail.sessionForm.venueNamePlaceholder":
      "e.g. Campus A - Main court",
    "classDetail.sessionForm.address": "Address",
    "classDetail.sessionForm.addressPlaceholder":
      "e.g. 12 Nguyen Hue, District 1, HCMC",
    "classDetail.sessionForm.searchingAddress": "Searching addresses...",
    "classDetail.sessionForm.noAddressSuggestion": "No matching suggestions",
    "classDetail.sessionForm.missingVietmapKey":
      "REACT_APP_VIETMAP_SERVICE_KEY isn't configured, so address suggestions are unavailable.",
    "classDetail.sessionForm.venueDescription": "Description (optional)",
    "classDetail.sessionForm.venueDescriptionPlaceholder":
      "e.g. Indoor training area",
    "classDetail.sessionForm.latitude": "Latitude",
    "classDetail.sessionForm.longitude": "Longitude",
    "classDetail.sessionForm.creatingVenue": "Creating...",
    "classDetail.sessionForm.createVenue": "Create and select venue",
    "classDetail.sessionForm.participants": "Actual session participants",
    "classDetail.sessionForm.studentCount": "{count} students",
    "classDetail.sessionForm.loadingParticipants": "Loading participants...",
    "classDetail.sessionForm.multiSelectHint":
      "Hold Ctrl/Cmd to select multiple managers.",
    "classDetail.sessionForm.selectTrainer": "Select trainer",
    "classDetail.sessionForm.searchStudents": "Search participating students",
    "classDetail.sessionForm.studentNamePlaceholder": "Enter student name...",
    "classDetail.sessionForm.noClassStudents":
      "There are no students in this class to add to the session.",
    "classDetail.sessionForm.delete": "Delete session",
    "classDetail.sessionForm.saveChanges": "Save changes",
    "classDetail.sessionForm.create": "Create session",

    "classDetail.enroll.title": "Add students to class",
    "classDetail.enroll.subtitle":
      "Search and quickly add students from the existing list.",
    "classDetail.enroll.searchLabel": "Search students by name",
    "classDetail.enroll.loading": "Loading students...",
    "classDetail.enroll.noMatch": "No matching students found",
    "classDetail.enroll.alreadyEnrolled": "Already enrolled",
    "classDetail.enroll.remainingSessions": "Remaining sessions",
    "classDetail.enroll.remainingPlaceholder": "Enter number of sessions...",
    "classDetail.enroll.adding": "Adding...",
  },
});
